import { NOOP_LOGGER } from "bernie-logger";
import { SerializedData, Store } from "bernie-core";

export const EMPTY_VERSION = "empty-version";
export const EMPTY_ENV = "empty-env";

export class DataDogStore extends Store {
  public static DEFAULTS = {
    version: EMPTY_VERSION,
    env: EMPTY_ENV,
  };

  public version: string;

  constructor(state: SerializedData = {}) {
    super(state, NOOP_LOGGER);
  }

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }
}
